import SiteTracker from './sitetracker';
import config from '../config/soj';
import {
  getScreen, getSourceH5, getSite, getAppName,
} from '../utils/common/soj';
import { isPlainObject } from '../utils/common/base';

let client = null;

export default {
  pageName: '',
  sendSoj(action = '', customparam, type = 1, site = 'anjuke', plat = 2, extendData = {
    pageName: '',
    ep: '',
  }) {
    const aSite = site || 'anjuke';
    const soj = SiteTracker;// new SiteTracker();
    let tParams = {};

    const pageName = extendData.pageName || this.pageName;
    soj.setCustomParam(customparam);

    const { hostname } = window.location;
    const reg = /.(anjuke.com|58.com)$/;
    if (!reg.test(hostname)) {
      tParams = {
        target_url: config.devSojURL,
      };
    }
    soj.setPage(pageName);
    soj.setSite(aSite);
    soj.setScreen(getScreen());
    soj.setReferer(document.referrer);

    soj.setPlat(plat || 2);
    soj.setType(type);
    if (extendData.ep) soj.setEp(extendData.ep);
    if (action && typeof action === 'string' && action.length > 0) {
      soj.setAction(action);
    }
    soj.track(tParams);
  },
  trackEvent(action, customparam, type = 2, curPageName = '', site = 'anjuke') {
    let cp = customparam;
    if (isPlainObject(customparam)) {
      cp = JSON.stringify(customparam);
    }
    this.sendSoj(action, cp, type || 2, site, 2, { pageName: curPageName });
  },
  sendPv(pageName, cp) {
    this.pageName = pageName;
    this.sendSoj('', JSON.stringify(cp), 1);
  },
  getClient() {
    return client && client.source_h5;
  },
  setClitent(val) {
    client = val;
  },
  sendClickSoj(action, clientObj = { source: 'unknow', version: 'unknow', system: 'unknow' }, cus_cp = {}) {
    const { source } = clientObj;
    const site = getSite(source);
    const formatClient = getSourceH5({ ...clientObj, source: getAppName(source) });
    const cp = Object.assign({}, formatClient, cus_cp);
    this.trackEvent(action, cp, 2, cus_cp.pageName, site);
  },
};
